import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TenantGeneralService {
  public XP_NAME = 'xavi-pay';
  public D_LOCAL_NAME = 'dlocal';
  public RR_CAMBIOS_NAME = 'rr-cambios';
  public D_WIRE_NAME = 'direct-wire';
  public WARREN_GLOBAL_NAME = 'warren-global';
  public WARREN_CAMBIO_NAME = 'warren-cambio';
  public GALAPAGOS_NAME = 'galapagos';
  public QBF_NAME = 'qbf';

  constructor() {}
}
